





















































































































































import { Watch, Component, Ref, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { CredentialsType } from '@/api/types'
import { TypeformCredentials } from '@/api/model/credentials'
import { TooltipStyling, TooltipAlign } from '../Tooltip.vue'
const referrals = namespace('referrals')
const orders = namespace('orders')

@Component
export default class NavigationBeta extends Vue {
    @referrals.Action applySearch: ({ query }) => Promise<void>
    @referrals.Action('applyView') referralsApplyView: ({ view: ReferralView, direction: ReferralFilterDirection, update: boolean }) => Promise<void>
    @referrals.Getter('activeDirection') referralsActiveDirection: string
    @orders.Action('applyView') ordersApplyView: ({ view: OrderView, direction: OrderFilterDirection, update: boolean }) => Promise<void>
    @orders.Getter('activeDirection') ordersActiveDirection: string
    @Ref() navigationBeta!: HTMLDivElement
    showSearch: boolean = false
    barLeft: number = 0
    barWidth: number = 0
    sliderIsVisible: boolean = true
    lastClickedElement: HTMLDivElement = null

    mounted() {
        this.setDefaultReferralsView()
        this.setDefaultOrdersView()
        this.updateNavigationSliderPosition(null)
        window.addEventListener('resize', this.updateNavigationSliderOnResize)
    }

    @Watch('$route.name')
    onRouteNameChanged() {
        setTimeout(() => {
            const selectedElement = this.navigationBeta.querySelector('.router-link-active')
            if (selectedElement) {
                this.lastClickedElement = selectedElement as HTMLDivElement
                this.updateNavigationSliderOnResize(null)
            }
        }, 100)
    }

    destroyed() {
        window.removeEventListener('resize', this.updateNavigationSliderOnResize)
    }

    setDefaultReferralsView(): void {
        this.referralsApplyView({
            view: this.$currentUser.defaultDashboardView,
            direction: this.referralsActiveDirection || 'in',
            update: true,
        })
    }

    setDefaultOrdersView(): void {
        this.ordersApplyView({
            view: this.$currentUser.defaultDashboardView,
            direction: this.ordersActiveDirection || 'in',
            update: true,
        })
    }

    get companyEnabledOrders(): boolean {
        if (!this.$currentCompany.orderSettings) {
            return false
        }

        return this.$currentCompany.orderSettings.enabled
    }

    get companyEnabledTypeform(): boolean {
        const credentials = this.$currentCompany.getCredentialsWithType(CredentialsType.TYPEFORM) as TypeformCredentials[]
        if (credentials.length === 0) {
            return false
        }

        return credentials[0].workspaceId !== null
    }

    goToSearch(query: string): void {
        this.showSearch = false

        if (this.$route.name !== 'tasks_all') {
            this.$router.push({ name: 'tasks_all' })
        }

        this.applySearch({ query })
    }

    get tooltipBetaStyling(): TooltipStyling {
        return TooltipStyling.BETA
    }

    get tooltipAlign(): TooltipAlign {
        return TooltipAlign.CENTER
    }

    get sliderStyle() {
        return {
            left: `${this.barLeft}px`,
            width: `${this.barWidth}px`,
        }
    }

    updateNavigationSliderOnResize(event: Event) {
        if (this.lastClickedElement === null) {
            const navElement = this.navigationBeta.firstElementChild

            this.barLeft = navElement.clientLeft
            this.barWidth = navElement.getBoundingClientRect().width
            return
        }

        const offsetX = this.navigationBeta.getBoundingClientRect().left
        this.barLeft = this.lastClickedElement.getBoundingClientRect().left - offsetX
        this.barWidth = this.lastClickedElement.getBoundingClientRect().width
    }

    updateNavigationSliderPosition(event: MouseEvent) {
        const element = event?.target as HTMLDivElement|undefined

        if (!element || element.matches('.logo-beta')) {
            const navElement = this.navigationBeta.firstElementChild
            this.barLeft = navElement.clientLeft
            this.barWidth = navElement.getBoundingClientRect().width
            return
        }

        if (element.matches('.new-navigation-link, .new-navigation-button')) {
            const bounds = element.parentElement.parentElement
            const offsetX = this.navigationBeta.getBoundingClientRect().left

            this.barLeft = bounds.getBoundingClientRect().left - offsetX
            this.barWidth = bounds.getBoundingClientRect().width
            this.sliderIsVisible = true
            this.lastClickedElement = element
        } else {
            return
        }
    }
}
